import { completeCheckoutStep } from './complete-checkout-step';
var defaultOrder = {};
export var completeAddressStep = function completeAddressStep() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOrder;
  return function (dispatch) {
    return dispatch(completeCheckoutStep({
      order: order,
      state: 'address'
    }));
  };
};